import { ScreeningServicePlan } from 'common/types/services/api/tenant-screening';
import { Modal } from 'components/organisms/Modal';
import { Button, Loader } from 'legacy-components/componets';

interface Props {
  isOpen: boolean;
  plans?: ScreeningServicePlan[];
  handleClose: () => void;
  handleSubmit: () => void;
}

const TenantScreeningConfirmationDialog = ({ isOpen, plans, handleClose, handleSubmit }: Props) => {
  const getRequestedPlanNames = (plans?: ScreeningServicePlan[]) => plans?.map(x => x.title).join(', ') || '';
  
  return (
    <Modal
      title={!plans ? <Loader /> : <div className='text-xl'>{`You have previously ordered ${getRequestedPlanNames(plans)}. Would you like to place another order?`}</div>}
      isOpen={isOpen}
      onClose={handleClose}
      contentClassName={'w-[500px]'}
      footer={
        <div className='flex gap-3 justify-end'>
          <Button label={'Cancel'} theme={'secondary'} onClick={handleClose} className={'w-full sm:w-auto'} />
          <Button
            disabled={!plans}
            label={'Request'}
            theme={'primary'}
            onClick={handleSubmit}
            className={'w-full sm:w-auto'}
          />
        </div>
      }
    />
  )
}

export default TenantScreeningConfirmationDialog